import Vue from 'vue';
import Router from 'vue-router';
import Index from './views/Index.vue';
import store from './store/store';

import Setting from './views/Setting.vue';
import TaskManage from './views/TaskManage.vue';
import PaperCheck from './views/PaperCheck.vue';
import MyCheckInfo from './views/MyCheckInfo.vue';

import ContrastCheck from './views/ContrastCheck.vue';
import OwnDbManage from './views/OwnDbManage.vue';
import Faq from './views/Faq.vue';

Vue.use(Router);

const constRouterMap: any = [];
export const asyncRouterMap = [{
    path: '/index',
    alias: '/',
    name: 'paperCheck',
    component: PaperCheck,
    meta: {
      title: '首页',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/paperCheck',
    name: 'paperCheck',
    component: PaperCheck,
    meta: {
      title: '文献送检',
      role: ['Master', 'SubAccount']
    }
  } ,{ 
    path: '/contrastCheck',
    name: 'contrastCheck',
    component: ContrastCheck,
    meta: {
      title: '比对库检测',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/myCheckInfo',
    name: 'myCheckInfo',
    component: MyCheckInfo,
    meta: {
      title: '检测信息',
      role: ['Master']
    }
  }, {
    path: '/taskManage',
    name: 'taskManage',
    component: TaskManage,
    meta: {
      title: '文件夹管理',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/owndbmanage',
    name: 'owndbmanage',
    component: OwnDbManage,
    meta: {
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/faq',
    name: 'faq',
    component: Faq,
    meta: {
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/setting',
    name: 'setting',
    component: Setting,
    meta: {
      role: ['Master']
    }
  }, {
    path: '/error',
    name: 'error',
    component: () => import('./views/Error.vue'),
    meta: {
      role: ['Master', 'SubAccount']
    }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constRouterMap
});

export default router;
